import { IMessageTemplate } from '../entities/IMessageTemplate';
import { httpClient } from './helper/httpClient';

export interface ICreateMessageTemplateParams {
  name: string;
  body: string;
}

export interface IUpdateMessageTemplateParams {
  name?: string;
  body?: string;
}

class MessageTemplateService {
  private _baseURL = 'message-templates';

  getAll(): Promise<IMessageTemplate[]> {
    return httpClient.get<null, IMessageTemplate[]>(this._baseURL);
  }

  create(data: ICreateMessageTemplateParams): Promise<IMessageTemplate> {
    return httpClient.post<null, IMessageTemplate>(this._baseURL, { ...data });
  }

  update(id: string, data: IUpdateMessageTemplateParams): Promise<void> {
    return httpClient.patch(`${this._baseURL}/${id}`, { ...data });
  }

  remove(id: string): Promise<void> {
    return httpClient.delete(`${this._baseURL}/${id}`);
  }
}

export default new MessageTemplateService();
